// ----------------------------
// Virtual Market
// ----------------------------

// ------------------------------------
// Imports
// ------------------------------------
import { put, call, takeLatest } from 'redux-saga/effects'
import {
  SEND_METRICS, sendMetricsSucceeded, sendMetricsFailed, GET_METRICS, getMetricsSucceeded, getMetricsFailed
} from '../modules/module_metrics.js'
import { API_REQUEST_STATUS_SUCCEEDED, API_REQUEST_STATUS_FAILED } from 'services/config'
import { doCallback } from 'utilities/general-utils'
import { updateMetricsStorage } from 'utilities/session-utils'
import { addIdBoletoMetrica } from 'utilities/metrics-utils'

// ------------------------------------
// Services
// ------------------------------------
import { sendMetricsUser, sendMetricsProducts, getMetricsByMarket } from 'services/metrics-api'

// ------------------------------------
// Sagas
// ------------------------------------

/* Sagas - Workers */
function* getMetricsByMarketWorker(action){
  const metrics = yield call(getMetricsByMarket, action.token, action.term.market);
  if (metrics.response) {
    yield put(getMetricsSucceeded(metrics.response.data));
    const metricsToUpdateInStorage = metrics.response.data;
    updateMetricsStorage(metricsToUpdateInStorage, 'metrics');
  } else {
    yield put(getMetricsFailed(metrics.error));
  }
}

function* sendMetricsRequested(action) {
  const { responseMetricsUser, errorMetricsUser } = yield call(sendMetricsUser, action.token, action.term);

  let actionToDo = null;
  let message = API_REQUEST_STATUS_FAILED;

  if (responseMetricsUser) {
    message = API_REQUEST_STATUS_SUCCEEDED;
    actionToDo = sendMetricsSucceeded(responseMetricsUser.data);
  } else {
    actionToDo = sendMetricsFailed(errorMetricsUser);
  }

  yield put(actionToDo);

  if (action.callback) {
    doCallback(action.callback, message);
  }

}

/* Sagas - Watchers/Listeners */
export function* watchSendMetrics() {
  yield takeLatest(SEND_METRICS, sendMetricsRequested);
}

export function* watchGetMetrics(){
  yield takeLatest(GET_METRICS, getMetricsByMarketWorker);
}

// ------------------------------------
// Exports Functions
// ------------------------------------

export const metricsSagas = [
    watchSendMetrics,
    watchGetMetrics
];



// WEBPACK FOOTER //
// ./src/store/sagas/sagas_metrics.js